/**
 * Helper: Algolia
 * -----------------------------------------------------------------------------
 * Functions used by Algolia
 * - Add in alphabetical order.
 *
 */

/**
 * Get Algolia facets from Shopify app
 * @returns {{value: String, label: String}[]}
 */
export function getAttributes() {
  const {
    collection_facets: algoliaFacets,
    facets: globalFacets,
  } = window.algoliaShopify?.config || {
    collection_Facets: { default: [] },
    facets: [],
  }
  const facets = []
  const allFacets = algoliaFacets?.default || globalFacets

  if (!allFacets) {
    return []
  }

  allFacets.forEach((facet) => {
    if (!facet.enabled) {
      return
    }
    facets.push({
      value: facet.name,
      label: facet.title,
    })
  })

  return facets
}

/**
 * Returns a slug from the category name.
 * Spaces are replaced by "+" to make the URL easier to read
 * and other characters are encoded.
 * @param {String} slug
 * @returns {String}
 */
export function getCategoryName(slug) {
  return slug.split('+').map(decodeURIComponent).join(' ')
}

/**
 * Returns a name from the category slug.
 * The "+" are replaced by spaces and other characters are
 * decoded.
 * @param {String} name
 * @returns {String}
 */
export function getCategorySlug(name) {
  return name.split(' ').map(encodeURIComponent).join('+')
}

/**
 * Add product on product card click to localstorage for the custom Algolia pixel to handle conversion
 * events. Removes product if the click originated elsewhere.
 * @see https://www.algolia.com/doc/integration/shopify/building-search-ui/events/?client=ruby#user-token-strategy
 * @param {object} product Algolia product
 * @returns
 */
export function handleAlgoliaClick(product) {
  if (!product?.algolia) {
    removeAlgoliaClick(product)
    return
  }

  const key = 'algolia_analytics_clicked_objects'
  const clickedObjects = JSON.parse(
    localStorage.getItem(key) || '[]',
  )

  let index = window.algoliaShopify?.config?.index_prefix
  index = index ? index + 'products' : 'shopify_products'

  clickedObjects.push({
    eventName: 'Added to cart',
    queryID: product.__queryID,
    objectIDs: [String(product.objectID)],
    productId: String(product.id),
    index: index,
  })

  localStorage.setItem(key, JSON.stringify(clickedObjects))
}

/**
 * Remove product from algolia clicked objects. This function is used assuming the
 * product card was not clicked from search.
 * @param {object} product Shopify product
 */
export function removeAlgoliaClick(product) {
  if (product?.algolia) {
    return
  }

  const key = 'algolia_analytics_clicked_objects'
  const clickedObjects = JSON.parse(
    localStorage.getItem(key) || '[]',
  ).filter((item) => {
    return item.productId !== String(product.id)
  })

  localStorage.setItem(key, JSON.stringify(clickedObjects))
}
